import { StudyOverviewData, StudyHubSiteGrid } from '@interfaces/central-monitoring';
import useSWRMutation from 'swr/mutation';
import { getData, ValidationErrorResponse } from '@apis/rest-client';

const StudyHubApi = {
    useGet: (studyRef: string, siteFilterSessionId: string, datasetId?: number, comparisonDataSetId?: number) => {
        const url = datasetId
            ? comparisonDataSetId !== undefined
                ? // eslint-disable-next-line max-len
                  `CentralMonitoring/Panels/${studyRef}/study-overview-data/${datasetId}/${comparisonDataSetId}?siteFilterSessionId=${siteFilterSessionId}`
                : `CentralMonitoring/Panels/${studyRef}/study-overview-data/${datasetId}?siteFilterSessionId=${siteFilterSessionId}`
            : null;

        return useSWRMutation<StudyOverviewData[], ValidationErrorResponse>(url, getData);
    },

    useGetStudyHubSiteGridData: (
        studyRef: string,
        siteFilterSessionId: string,
        datasetId?: number,
        comparisonDataSetId?: number,
    ) => {
        let url = null;

        if (datasetId) {
            url = `CentralMonitoring/Panels/${studyRef}/site-overview-data/${datasetId}`;

            if (comparisonDataSetId !== undefined) {
                url += `/${comparisonDataSetId}`;
            }

            url += `?siteFilterSessionId=${siteFilterSessionId}`;
        }

        return useSWRMutation<StudyHubSiteGrid, ValidationErrorResponse>(url, getData);
    },
};

export default StudyHubApi;
